import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useModalObserver from "src/recoil/modal-observer/hooks";
import BaseButton from "./BaseButton";
import BaseButtonSm from "./BaseButtonSm";

interface state {
  isOpen: boolean;
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
  btnLeftTitle?: string;
  btnRightTitle?: string;
  type?: string;
  btnRightType?: "button" | "submit" | "reset" | undefined;
  className?: string;
  title?: string;
  btnRightDisable?: boolean;
}

export const PublicModal = (props: state) => {
  const el = document.getElementById("modal");

  const { generateId, subscribe, unsubscribe } = useModalObserver();
  const [modalId] = useState(() => generateId());
  // const [firstButtonRef, setFirstButtonRef] = useState<RefObject<HTMLButtonElement>>();

  useEffect(() => {
    subscribe(modalId, {
      Escape: () => props.onClose && props.onClose({} as React.MouseEvent<HTMLButtonElement>),
      // Enter: () => {
      //   firstButtonRef?.current?.focus();
      // },
    });

    return () => {
      unsubscribe(modalId);
    };
  }, []);

  if (!props.isOpen) return null;

  return createPortal(
    <>
      <div className={"dim"}>
        <div className={`public-modal pre-formatted ${props.className ? props.className : ""}`}>
          {props.title && (
            <div className="public-modal__title">
              <span>{props.title}</span>
            </div>
          )}
          {props.children && (
            <div className={`${props.title ? "base-modal__contents pt20" : "base-modal__contents"} keep-all`} style={{ lineHeight: "1.5" }}>
              {props.children && <>{props.children}</>}
            </div>
          )}
          {(props.btnLeftTitle !== undefined || props.btnRightTitle !== undefined) && (
            <div className="base-modal__btn-wrap mt30">
              {props.btnLeftTitle && (
                <BaseButtonSm
                  title={props.btnLeftTitle}
                  onClick={props.onClose}
                  className={`${props.btnLeftTitle && props.btnLeftTitle !== "" ? "color-white" : ""} mr10 minmax120`} //
                  height={42}
                />
              )}
              {props.btnRightTitle && (
                <BaseButtonSm
                  title={props.btnRightTitle}
                  type={props.btnRightType ? props.btnRightType : undefined}
                  onClick={props.onClick}
                  className="minmax120"
                  disabled={props.btnRightDisable}
                  height={42}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>,
    el!,
  );
};
